import { memo } from 'react';
import { Badge } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { MEMBER_STATUS_META, NEW_BADGE_META } from '../../constants/copy';

/**
 * Member status badge (Active, Invited, Expired, Not invited, Suspended, Removed), plus the
 * transient New badge. Label and variant come from the central vocabulary. `showStatus={false}`
 * leaves the status out and keeps New (a table row never badges Active, the default).
 */
const StatusBadge = ({ status, isNew = false, showStatus = true }) => {
  const { t } = useTranslation('people-access');
  const meta = MEMBER_STATUS_META[status];

  if (!meta) return null;

  return (
    <span className="inline-flex items-center gap-1">
      {showStatus && <Badge variant={meta.variant}>{t(meta.labelKey)}</Badge>}
      {isNew && <Badge variant={NEW_BADGE_META.variant}>{t(NEW_BADGE_META.labelKey)}</Badge>}
    </span>
  );
};

export default memo(StatusBadge);
